package org.zq.linkgame

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.safeContentPadding
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import org.zq.linkgame.ui.navigation.LinkGameNavigation
import org.zq.linkgame.ui.theme.LinkGameTheme

@Composable
@Preview
fun App() {
    LinkGameTheme {
        Surface(
            modifier = Modifier
                .safeContentPadding()
                .fillMaxSize()
        ) {
            LinkGameNavigation()
        }
    }
}